// ─── Un élément qu'on vient de créer prend son jeton (Core) ───────
// Créer un calendrier, un inventaire, un plan… doit AVOIR le même effet partout :
// l'élément entre dans la file avec un jeton ⚙️ (on le gère, on vient de le
// faire). Sans ce geste commun, chaque module l'oubliait — ou l'implémentait à
// sa façon — et l'élément créé restait invisible.
//
//   const prendreJeton = usePrendreJeton();
//   const id = await creerInventaire(…);
//   await prendreJeton(`inventaire:${id}`);   // lève si le serveur refuse
//
// L'appelant DOIT laisser remonter l'erreur : si le serveur refuse (plus de
// jeton libre), l'élément existe mais n'apparaîtra pas — l'utilisateur doit le
// savoir, pas découvrir un écran inchangé.
import { useCallback } from 'react';
import { useAuth } from '../auth/AuthContext';
import { choisirElements } from './jetonsService';
import { useJetons } from './useJetons';

export function usePrendreJeton() {
  const { user } = useAuth();
  const { selection, sansLimite, jamaisEnregistre, droitImplicite } = useJetons();

  return useCallback(async (cle, elementsConnus = []) => {
    // Sans limite (fonction absente du forfait, ou coupée par un valideur), la
    // file ne sert à rien : tout est visible, il n'y a rien à réserver.
    if (sansLimite || !cle || !user?.uid) return;
    // Rien d'enregistré : on matérialise d'abord le choix IMPLICITE (les N
    // premiers éléments), sinon l'enregistrement effacerait ce que l'écran
    // montrait jusque-là.
    const base = jamaisEnregistre
      ? Object.entries(droitImplicite(elementsConnus)).map(([c, nature]) => ({ cle: c, nature }))
      : (selection || []);
    if (base.some(x => x.cle === cle && !x.pour)) return;
    await choisirElements([...base, { cle, nature: 'gestion' }]);
  }, [user?.uid, selection, sansLimite, jamaisEnregistre, droitImplicite]);
}

export default usePrendreJeton;
